import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TurnstileService {
  private token = '';

  setToken(token: string): void {
    this.token = token;
  }

  getToken(): string {
    return this.token;
  }

  hasToken(): boolean {
    return !!this.token;
  }

  clearToken(): void {
    this.token = '';
  }
}
